/** 创建空对象 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function createEmptyObject<O = {}>(): O {
  return Object.create(null);
}

/**
 * 对象取属性
 */
export function pick<T, K extends keyof T>(o: T, keys: K[] = []): Pick<T, K> {
  const res = Object.create(null);
  if (o == null) return o;
  keys.forEach((k) => (res[k] = o[k]));
  return res;
}

/**
 * 对象忽略属性
 */
export function omit<T, K extends keyof T>(o: T, keys: K[] = []): Omit<T, K> {
  if (o == null) return o;
  const res = {
    ...o,
  };
  keys.forEach((k) => delete res[k]);
  return res;
}

/**
 * 判断空对象
 */
export function isEmptyObject<T>(data: T): boolean {
  return Object.keys(data ?? {}).length === 0;
}

export function shrink<T extends Record<string, unknown>>(o: T, exclude: (value: unknown) => boolean): T {
  const ret: T = createEmptyObject();
  for (const key in o) {
    if (Object.hasOwn(o, key)) {
      const value = o[key];
      if (!exclude(value)) ret[key] = value;
    }
  }
  return ret;
}